import { approvePermission, type ApprovableCommand } from '@ruby-cms/shared';

// Duyet / Tu choi tren Chi tiet lenh: lenh con cho duyet va admin co quyen duyet dung theo quy tac chung voi API
// (@ruby-cms/shared approvePermission, task cms-quyen-hien-thi). Lenh chi chu so huu: API tra 404 cho vai tro khac,
// trang khong hien.
export const mayDecide = (c: ApprovableCommand & { status: string }, can: (p: string) => boolean) => c.status === 'AWAITING_APPROVAL'
  && can(approvePermission(c));
